export enum ClientTypeEnum {
  NATURAL_PERSON = "NATURAL_PERSON",
  LEGAL_ENTITY = "LEGAL_ENTITY"
}

export enum LegalEntityTypeEnum {
  FINANCIAL_INSTITUTION = "FINANCIAL_INSTITUTION",
  LISTED_COMPANY = "LISTED_COMPANY",
  PUBLIC_ENTITY = "PUBLIC_ENTITY",
  OTHER_LEGAL_ENTITY = "OTHER_LEGAL_ENTITY"
}

export enum JobEnum {
  PUBLIC_SECTOR = "PUBLIC_SECTOR",
  PRIVATE_SECTOR = "PRIVATE_SECTOR",
  BUSINESS_OWNER = "BUSINESS_OWNER",
  LIBERAL_PROFESSION = "LIBERAL_PROFESSION",
  RETIRED = "RETIRED",
  STUDENT = "STUDENT",
  OTHER = "OTHER"
}

export enum ProfessionalSectorEnum {
  GAMBLING = "GAMBLING",
  ARMS_DEFENSE = "ARMS_DEFENSE",
  REAL_ESTATE = "REAL_ESTATE",
  FINANCIAL_SERVICES = "FINANCIAL_SERVICES",
  CRYPTO = "CRYPTO",
  LUXURY = "LUXURY",
  HEALTH_PHARMA = "HEALTH_PHARMA",
  TECHNOLOGY = "TECHNOLOGY",
  RETAIL = "RETAIL",
  EDUCATION = "EDUCATION",
  INDUSTRY = "INDUSTRY",
  AGRICULTURE = "AGRICULTURE",
  OTHER = "OTHER"
}

export enum FundsOriginEnum {
  SALARY = "SALARY",
  SAVINGS = "SAVINGS",
  INHERITANCE = "INHERITANCE",
  REAL_ESTATE_SALE = "REAL_ESTATE_SALE",
  BUSINESS_SALE = "BUSINESS_SALE",
  INVESTMENT_INCOME = "INVESTMENT_INCOME",
  OTHER = "OTHER"
}

export enum WealthOriginEnum {
  PROFESSIONAL_INCOME = "PROFESSIONAL_INCOME",
  INHERITANCE = "INHERITANCE",
  REAL_ESTATE = "REAL_ESTATE",
  FINANCIAL_INVESTMENTS = "FINANCIAL_INVESTMENTS",
  BUSINESS_SALE = "BUSINESS_SALE",
  GIFT = "GIFT",
  OTHER = "OTHER"
}

export enum MaritalStatusEnum {
  SINGLE = "SINGLE",
  COHABITING = "COHABITING",
  PACS = "PACS",
  MARRIED = "MARRIED",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED"
}

export enum MatrimonialRegimeEnum {
  COMMUNITY_REDUCED_ACQUESTS = "COMMUNITY_REDUCED_ACQUESTS",
  UNIVERSAL_COMMUNITY = "UNIVERSAL_COMMUNITY",
  SEPARATION_OF_PROPERTY = "SEPARATION_OF_PROPERTY",
  PARTICIPATION_ACQUESTS = "PARTICIPATION_ACQUESTS",
  PACS_SEPARATION = "PACS_SEPARATION",
  PACS_INDIVISION = "PACS_INDIVISION"
}

export enum PaymentMethodEnum {
  BANK_TRANSFER = "BANK_TRANSFER",
  CREDIT_CARD = "CREDIT_CARD",
  // No longer selectable in the client-facing form, but the backend's LCB-FT grid still accepts
  // them and older declarations can carry these values — kept here so display doesn't break.
  DIRECT_DEBIT = "DIRECT_DEBIT",
  CHEQUE = "CHEQUE"
}

export enum IncomeSourceEnum {
  SALARY = "SALARY",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  PROPERTY_INCOME = "PROPERTY_INCOME",
  DIVIDENDS = "DIVIDENDS",
  PENSION = "PENSION",
  OTHER = "OTHER"
}

export enum FinancialInstrumentsKnowledgeEnum {
  FAIBLE = "FAIBLE",
  MOYENNE = "MOYENNE",
  ELEVEE = "ELEVEE"
}

export enum PriorServiceEnum {
  NONE = "NONE",
  PRIVATE_BANKING = "PRIVATE_BANKING",
  CREDIT = "CREDIT",
  CRYPTO_SERVICE_PROVIDER = "CRYPTO_SERVICE_PROVIDER",
  DISCRETIONARY_MANAGEMENT = "DISCRETIONARY_MANAGEMENT",
  OTHER = "OTHER"
}

export enum ManagedAssetCategoryEnum {
  TRADITIONAL_ONLY = "TRADITIONAL_ONLY",
  CRYPTO = "CRYPTO",
  BOTH = "BOTH"
}

export enum CryptoAdviceOutcomeEnum {
  RECEIVED_AND_INVESTED = "RECEIVED_AND_INVESTED",
  NEVER_RECEIVED = "NEVER_RECEIVED",
  RECEIVED_NOT_INVESTED = "RECEIVED_NOT_INVESTED"
}

export enum CryptoAllocationRatioEnum {
  UP_TO_2 = "UP_TO_2",
  UP_TO_5 = "UP_TO_5",
  UP_TO_10 = "UP_TO_10",
  UP_TO_20 = "UP_TO_20",
  MORE_THAN_20 = "MORE_THAN_20"
}

export enum WealthInvestmentRatioEnum {
  LESS_THAN_5 = "LESS_THAN_5",
  BETWEEN_5_15 = "BETWEEN_5_15",
  BETWEEN_15_30 = "BETWEEN_15_30",
  MORE_THAN_30 = "MORE_THAN_30"
}

export enum IncomeCoversChargesEnum {
  COMFORTABLE = "COMFORTABLE",
  LIMITED_MARGIN = "LIMITED_MARGIN",
  DEPENDENT = "DEPENDENT"
}

// Not populated in practice yet — will be `null` on nearly every record for now.
export enum DistributionChannelEnum {
  DIRECT_IN_PERSON = "DIRECT_IN_PERSON",
  DIRECT_REMOTE_WITH_MEASURES = "DIRECT_REMOTE_WITH_MEASURES",
  DIRECT_REMOTE = "DIRECT_REMOTE",
  INTERMEDIATED_REGULATED_CIF = "INTERMEDIATED_REGULATED_CIF",
  INTERMEDIATED_UNREGULATED = "INTERMEDIATED_UNREGULATED",
  INTERMEDIATED_NON_COMPLIANT = "INTERMEDIATED_NON_COMPLIANT"
}
